import React, { useState, useEffect } from 'react';
import { personalInfo } from '../data/portfolio';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#about', label: 'About' },
    { href: '#skills', label: 'Skills' },
    { href: '#projects', label: 'Projects' },
    { href: '#experience', label: 'Experience' },
    { href: '#contact', label: 'Contact' },
  ];

  const handleNavClick = () => setIsMenuOpen(false);

  return (
    <header className={`header ${isScrolled ? 'header--scrolled' : ''}`} role="banner">
      <div className="container header__container">
        <a href="/" className="header__logo" aria-label={`${personalInfo.name} - Home`}>
          <span className="header__logo-text">{personalInfo.name}</span>
        </a>

        <nav className={`header__nav ${isMenuOpen ? 'header__nav--open' : ''}`} role="navigation" aria-label="Main navigation">
          <ul className="header__nav-list">
            {navLinks.map((link) => (
              <li key={link.href} className="header__nav-item">
                <a href={link.href} className="header__nav-link" onClick={handleNavClick}>
                  {link.label}
                </a>
              </li>
            ))}
            <li className="header__nav-item header__nav-item--cta">
              <a href={personalInfo.resume} className="btn btn--primary header__nav-cta" download>
                Resume
              </a>
            </li>
          </ul>
        </nav>

        <div className="header__actions">
          <a href={personalInfo.resume} className="btn btn--primary header__cta" download>
            Resume
          </a>
          <button
            className="header__menu-btn"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-expanded={isMenuOpen}
            aria-controls="main-navigation"
            aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          >
            <span className="header__menu-icon" aria-hidden="true">
              {isMenuOpen ? (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              ) : (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="3" y1="12" x2="21" y2="12" />
                  <line x1="3" y1="6" x2="21" y2="6" />
                  <line x1="3" y1="18" x2="21" y2="18" />
                </svg>
              )}
            </span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
